var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.publisher)?_c('div',{staticClass:"live-data-publisher-info",class:{ 'as-list-item-detail': _vm.asListItemDetail }},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t('common.labels.liveData')))]),_c('tag',{staticClass:"publisher-tag",attrs:{"label":_vm.publisher}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }